<template>
  <div class="pop">
    <div class="scansolution">
      <div class="close" @click="close"><Icon type="md-close" /></div>
      <div class="top">主观题阅卷</div>
      <div class="middle">
        <div class="left">
          <div class="question">
            <p>问题：</p>
            <p v-html="message.question"></p>
          </div>
          <div class="answer" style="color: #2a6be4;">
            <p>标准答案：</p>
            <p style="text-indent:2em;">{{message.questionanswer}}</p>
          </div>
          <div class="answer">
            <p>考生答案：</p>
            <p style="text-indent:2em">{{itemdata.esuseranswer}}</p>
          </div>
        </div>
        <div class="right">
          <div style="text-align:center">
            <RadioGroup v-model="status" @on-change="statuschange" type="button" size="large">
                <Radio :label="0">未阅卷</Radio>
                <Radio :label="1">已阅卷</Radio>
            </RadioGroup>
          </div>
          <div class="item">
            <div>考卷ID</div>
            <div>
              <Select @on-change="change" v-model="itemdata.ehid" style="width:1.9rem">
                <Option v-for="item in list" :key="item" :value="item">{{item}}</Option>
              </Select>
            </div>
          </div>
          <div class="item">
            <div>考生编号</div>
            <div>
              <div class="show">{{itemdata.ehuserid}}</div>
            </div>
          </div>
          <div class="item">
            <div>考生姓名</div>
            <div>
              <div class="show">{{itemdata.ehusername}}</div>
            </div>
          </div>
          <div class="item">
            <div>提交时间</div>
            <div>
              <div class="show">{{itemdata.escreatetime|formatetime}}</div>
            </div>
          </div>
          <div class="item">
            <div>得分</div>
            <div>
                <InputNumber :max="Number(message.questionscore)" :min="0" v-model="itemdata.esscore"></InputNumber>
            </div>
          </div>
          <div style="margin-top:20px;text-align:center">
            <Button type="primary"  style="width:90%" @click="submit"> 提交</Button>
          </div>
          <div class="bottom"></div>
        </div>
      </div>
      <div class="albotttom">
        <Button type="primary" :disabled="count==0" style="margin-right:100px;" @click="getpre">上一份</Button>
        <Button type="primary" :disabled="count==(list.length-1)" @click="getnext">下一份</Button>
      </div>
    </div>
  </div>
</template>
<script>
import {
  ExamScore_questionList,
  ExamScore_getSubject,
  ExamScore_grade
} from "../../assets/js/api.js";
export default {
  data() {
    return {
      list: [],
      itemdata: {
        ehid: "",
        ehuserid: "",
        ehusername: "",
        escreatetime:"",
        esscore: 0,
        esuseranswer: "",
      },
      count: 0,
      status:0
    };
  },
  props: ["message", "examid"],
  mounted() {
    this.getlist();
  },
  methods: {
    close() {
      this.$emit("close");
    },
    //状态改变
    statuschange(){
      this.count=0
      this.getlist()
    },
    // 阅卷
    submit() {
      if(this.itemdata.esscore==null){
        this.errorPlus('评分不能为空')
        return
      }
      var data={}
      // ehid	string	true	普通参数		考试记录id
      // questionid	string	true	普通参数		试题id
      // score	string	true	普通参数		评分
      data.ehid = this.itemdata.ehid
      data.questionid = this.message.questionid
      data.score = this.itemdata.esscore

      ExamScore_grade(data).then(res => {
        if (res.data.code == 200) {
        this.$Notice.success({ title: '成功提示',desc:'评分成功！'});
          return
        }
           this.$Notice.warning({ title: "信息提示", desc: res.data.message });
      });
    },
    getlist() {
      var data = {};
      // examid	string	true	普通参数		考试id
      // questionid	string	true	普通参数		试题id
      // status
      data.examid = this.examid;
      data.questionid = this.message.questionid;
      data.status = this.status;
      ExamScore_questionList(data).then(res => {
        if (res.data.code == 200) {
          this.list = res.data.data;
          this.getdata();
          return
        }
        this.$Notice.warning({ title: "信息提示", desc:(this.status==0?"未阅卷状态":"已阅卷状态") + res.data.message});
        if(this.status==0){
          this.status=1
        }else{
          this.status=0
        }
        this.statuschange()
      });
    },
    getdata(id) {
      var data = {};
      data.questionid = this.message.questionid;
      if (id) {
        data.ehid = id;
      } else {
        data.ehid = this.list[this.count];
      }
      ExamScore_getSubject(data).then(res => {
        if (res.data.code == 200) {
          this.itemdata = res.data.data[0];
          this.itemdata.esscore =Number( this.itemdata.esscore)
          return;
        }
        this.errorPlus(res.data.messages);
      });
    },
    getnext() {
      if (this.count < this.list.length-1) {
        this.count++;
        this.getdata();
      }
    },
    getpre() {
      if (this.count > 0) {
        this.count--;
        this.getdata();
      }
    },
    change(data) {
      if(data){
        this.count =  this.list.indexOf(data)
        this.getdata(data);
      }
    }
  }
};
</script>
<style lang="css" scoped>
.pop {
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.1);
  z-index: 1000;
  width: 100%;
  height: 100%;
}
.scansolution {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 8.73rem;
  height: 5.11rem;
  transform: translate(-50%, -50%);
  background: #fff;
  border-radius: 10px;
}
.close{
  position: absolute;
  top: 0px;
  right: 5px;
  color: #bbb;
  font-size: 22px;
}
.top {
  height: 0.8rem;
  text-align: center;
  color: #3a4047;
  font-size: 0.24rem;
  line-height: 0.8rem;
}
.middle {
  padding: 0 0.25rem;
  box-sizing: border-box;
  display: flex;
  justify-content: flex-start;
  text-align: left;
}
.left {
  width: 5.3rem;
  height: 3.5rem;
  overflow-y: auto;
  background: #f2f4f8;
  border-radius: 10px;
  padding: 0.15rem 0.2rem;
}
.right {
  position: relative;
}
.question {
  line-height: 0.26rem;
  font-size: 0.14rem;
  color: #2a6be4;
}
.answer {
  margin-top: 0.2rem;
  line-height: 0.26rem;
  font-size: 0.14rem;
  color: #575e6b;
}
.item {
  display: flex;
  justify-content: flex-start;
  margin: 0.2rem 0;
}
.item > div:first-child {
  width: 0.9rem;
  line-height: 0.3rem;
  text-align: right;
  margin-right: 0.15rem;
}
.show {
  width: 1.9rem;
  height: 0.32rem;
  border: 1px solid #e8e9ee;
  line-height: 0.32rem;
  border-radius: 5px;
  padding: 0 0.1rem;
}
.bottom {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding-left: 0.3rem;
}
.button {
  width: 0.9rem;
  height: 0.3rem;
  border-radius: 3px;
  line-height: 0.3rem;
  text-align: center;
  background: #ffd6de;
  color: #ff064e;
  font-size: 0.14rem;
  font-weight: bold;
  display: inline-block;
}
.albotttom {
  display: flex;
  justify-content:center;
  margin-top: 0.3rem;
  line-height: 0.3rem;
}
</style>



// WEBPACK FOOTER //
// src/components/toast/scansolution.vue